import React, { useState, useEffect } from 'react';
import { Accordion, AccordionBody } from '../common/Accordion';
import { getCountries, getCountryCode } from '../../actions/RegisterActions'
import { updateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert'
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';


const EditProfileInfo = (props) => {
    const detail = props.detail
    const currentDate = moment().format('YYYY-MM-DD');
    const minBirthYear=moment(currentDate).subtract(25,'years').format('YYYY-MM-DD')
    const maxBirthYear=moment(currentDate).subtract(10,'years').format('YYYY-MM-DD')


    const [name, setName] = useState({ name: 'name', value: '', error: '', isRequired: true });
    const [dob, setDob] = useState({ value: '', error: '', isRequired: false });
    // const [studentPhoto, setStudentPhoto] = useState({ value: '', error: '', isRequired: false });
    const [studentEmail, setStudentEmail] = useState({ name: 'studentEmail', value: '', error: '', isRequired: false });
    const [studentMobile, setStudentMobile] = useState({ name: 'studentMobile', value: '', error: '', isRequired: false });
    const [targetExam, setTargetExam] = useState({ name: 'targetExam', value: '', error: '', isRequired: false });

    const [countryCode, setCountryCode] = useState({ name: 'countryCode', value: '', error: '', isRequired: false });
    const [gender, setGender] = useState({ name: 'gender', value: '', error: '', options: [], isRequired: false });
    const [profilePic, setProfilePic] = useState({ name: 'profilePicture', value: '', error: '', options: [], isRequired: false });
    const [tShirtSize,setTshirtSize] = useState({name:'tshirtSize',value:'',error:''});
    
    const [editDetail, setEditDetail] = useState(false);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const detail = props.detail
        if (detail !== undefined) {
            setName({ ...name, value: detail.name })
            setDob({ ...dob, value: detail.dob })
            setStudentEmail({ ...studentEmail, value: detail.student_email })
            setStudentMobile({ ...studentMobile, value: detail.student_mobile })
            setTargetExam({ ...targetExam, value: detail.target_exam })
            setCountryCode({ ...countryCode, value: detail.country_code })
            setGender({ ...gender, value: detail.gender }) 
            setTshirtSize({ ...tShirtSize, value: detail.tshirt_size }) 
            // setProfilePic({ ...profilePic, value: detail.profile_picture })
            // setArea({ ...area, value: detail.area })
            // setFatherName({ ...fatherName, value: detail.father_name })
            // setAddress1({ ...address1, value: detail.address1 })
            // setAddress2({ ...address2, value: detail.address2 })
        }
    }, [detail.name,
        detail.dob,
        detail.studentEmail,
        detail.studentMobile,
        detail.targetExam,
        detail.gender,
        detail.profilePic,
         detail.country_code,
         detail.tshirt_size])

    useEffect(async () => {
        const detail = props.detail !== undefined && props.detail
        if (detail !== undefined) {
            const countryRes = await getCountries();
            const countryCodeRes = await getCountryCode(detail.country_id)
            setCountryCode({ ...countryCode, options: countryCodeRes.data, value: detail.country_code })
        }

    }, [detail.country_code])

    const editPersonalDetail = () => {
        setEditDetail(true)
    }

    const handleCancel = () => {
        setEditDetail(false)
    }

    const handleCountryChange = (e) => {

        getCountryCode(e.target.value)
            .then((res) => {
                setCountryCode({ ...countryCode, options: res.data, value: res.data.isd_code })
        });
    }

    // const handleTshirtSize = (e) => {
    //     setTshirtSize({ ...tShirtSize, value: e.target.value, error: '' })
    // }


    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let emailRegex = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        let formIsValid = true
        if (!gender.value) {
            formIsValid = false
            let msg = "Please select gender"
            setGender({ ...gender, error: msg })
        }
   
        if (!targetExam.value) {
            formIsValid = false
            let msg = "Please select target exam"
            setTargetExam({ ...targetExam, error: msg })
        }

        // if (!profilePic.value) {
        //     formIsValid = false
        //     let msg = "Please upload profile picuture"
        //     setProfilePic({ ...profilePic, error: msg })
        // }

        // Student Name
        if (!name.value) {
            formIsValid = false
            let msg = "Please enter name"
            setName({ ...name, error: msg })
        }
        else if (name.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setName({ ...name, error: msg })
        }
        else if (name.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setName({ ...name, error: msg })
        }
        else if (!nameRegex.test(name.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setName({ ...name, error: msg })
        }

         // Student email
        // Email validation
        if (!studentEmail.value) {
            formIsValid = false
            let msg = "Please enter email"
            setStudentEmail({ ...studentEmail, error: msg })
        }
        else if (studentEmail.value.length < 13) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setStudentEmail({ ...studentEmail, error: msg })
        }
        else if (studentEmail.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length"
            setStudentEmail({ ...studentEmail, error: msg })
        }

        else if (!emailRegex.test(studentEmail.value)) {
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setStudentEmail({ ...studentEmail, error: msg })
        }
          // Student mobile
          if (!studentMobile.value) {
            formIsValid = false
            let msg = "Please enter mobile number"
            setStudentMobile({ ...studentMobile, error: msg })
        }
        
        else if (studentMobile.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setStudentMobile({ ...studentMobile, error: msg })
        }
        else if (studentMobile.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setStudentMobile({ ...studentMobile, error: msg })
        }
        // else if (!mobileRegex.test(studentMobile.value)) {
        //     formIsValid = false
        //     let msg = "Enter a valid Mobile Number"
        //     setStudentMobile({ ...studentMobile, error: msg })
        // }
        // Dob
        if (!dob.value) {
            formIsValid = false
            let msg = "Please select date of birht"
            setDob({ ...dob, error: msg })
        }

        // if (!tShirtSize.value) {
        //     formIsValid = false
        //     let msg = "Please select your t-shirt size"
        //     setTshirtSize({ ...tShirtSize, error: msg })
        // }

        if (formIsValid) {
            setName({ ...name, error: '' });
            setGender({ ...gender, error: '' })
            setDob({ ...dob, error: '' });
            setStudentEmail({ ...studentEmail, error: '' });
            setStudentMobile({ ...studentMobile, error: '' });
            setTargetExam({ ...targetExam, error: '' });
            // setTshirtSize({...tShirtSize,error:''})
        }

        return formIsValid;

    }


    const onSubmit = async (e) => {
        e.preventDefault();
        
        if (validation()) {
            setLoading(true)
            const data = {
                name: name.value,
                gender: gender.value,
                country_code: countryCode.value,
                target_exam:targetExam.value,
                student_email:studentEmail.value,
                student_mobile:studentMobile.value,
                dob:dob.value,
                // tshirt_size:tShirtSize.value,
            }

            data.id = detail.id
            await updateProfileDetail(data).then(res => {
                if (res.status) {
                    setEditDetail(false)
                    setLoading(false)
                    swal('Data updated successfully', '', 'success')
                    props.onSubmit(res)
                }
                else {
                    setLoading(false)
                    swal('Something went wrong', '', 'error')
                }
            })
                .catch(err => {
                    console.log(err);
                })
        }




    }
    return (
        <>
            <Accordion title="Personal Details" collapseName="editProfileInfo">
                <AccordionBody>
                    <form  className="hold_mandatoryField">
                        <div className="row mb-4">
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating">
                                    <input type="text"
                                        className="form-control"
                                        id="floatingInput"
                                        placeholder="Student's Full Name"
                                        value={name.value!==null?name.value:''}
                                        disabled={detail.is_paid ==1 ||!editDetail}
                                        onChange={(e) => {
                                        let value = e.target.value
                                        value = value.replace(/[^A-Za-z- ]/ig, '')
                                        setName({ ...name, value: value, error: '' })
                                    }
                                    }
                                    />
                                    <label>Student Name</label>
                                </div>
                                {name.error.length > 0 && <div className='invalidFeedback'>{name.error}</div>}
                            </div>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="date" min={minBirthYear} disabled={!editDetail}  max={maxBirthYear} className="form-control" name="dob"
                                        placeholder="Date of birth" value={dob.value!==null?dob.value:''} onChange={(e) =>
                                            setDob({ ...dob, value: e.target.value, error: '' })}
                                    />
                                    <label>Date of birth</label>
                                </div>
                                {dob.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{dob.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" disabled={!editDetail} className="form-control" name="studentEmail"
                                        placeholder="Student/Communication mail ID"   value={studentEmail.value!==null?studentEmail.value:''} onChange={(e) =>
                                            setStudentEmail({ ...studentEmail, value: e.target.value, error: '' })} 
                                    />
                                    <label className='optional'>Student/Communication mail ID</label>
                                </div>
                                {studentEmail.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{studentEmail.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className='d-flex'>
                                    <div className="form-floating diff_disable country_codeField d-inline px-2 ps-0">
                                        <input type="text"
                                            className="form-control"
                                            id="floatingInput" placeholder="country code "
                                            value={countryCode.value!==null?countryCode.value:''}
                                            disabled
                                            onChange={(e) => setCountryCode({ ...countryCode, value: e.target.value })} />
                                        <label className='optional'>Country code</label>
                                    </div>
                                    <div className="form-floating d-inline w-100 diff_disable">
                                    <input type="number" className="form-control" name="studentMobile"
                                        placeholder="Student's Mobile" maxLength="16"  disabled={!editDetail} value={studentMobile.value!==null?studentMobile.value:''} onChange={(e) =>
                                            setStudentMobile({ ...studentMobile, value: e.target.value, error: '' })} 
                                    />
                                    <label className='optional'>Student's Mobile</label>
                                </div>
                                </div>
                                {studentMobile.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{studentMobile.error}</div>}
                            </div>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floating">
                                    <select className="form-control"
                                        data-val="true" data-val-required="Gender required" id="gender"
                                        name="gender" required="required"
                                        value={gender.value!==null?gender.value:''}
                                        disabled={!editDetail}
                                        onChange={(e) => setGender({ ...gender, value: e.target.value, error: '' })}>
                                        <option value="">Please Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    {editDetail && <span className='nrml_dwnArrow'><FontAwesomeIcon icon={faChevronDown}/></span>}
                                    <label htmlFor="floatingInput">Gender</label>
                                </div>
                                {gender.error.length > 0 && <div className='invalidFeedback'>{gender.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <select value={targetExam.value!==null?targetExam.value:''} disabled={!editDetail}  className="form-select" name="targetExam" 
                                    onChange={(e) =>
                                        setTargetExam({ ...targetExam, value: e.target.value,error :'' })}
                                        >
                                        <option value="">Choose</option>
                                        <option value="jee">JEE</option>
                                        <option value="neet">NEET</option>
                                        <option value="foundation">FOUNDATION</option>
                                    </select>
                                    <label>Target Exam</label>
                                </div>
                                {targetExam.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{targetExam.error}</div>}
                            </div>

                            {/* <div className='col-lg-12 mb-3 px-lg-4 t-shirt-size-contain'>
                                <h6>Size of T-shirt<span className='mendtory_field fs-4 text-danger'>*</span> : </h6>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize" onChange={handleTshirtSize} disabled={!editDetail}  defaultChecked={detail?.tshirt_size === 'XXXS (32)'} id="XXXS(32)" value="XXXS (32)"/>
                                <label className="form-check-label" htmlFor="XXXS(32)">XXXS (32)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize} disabled={!editDetail}  defaultChecked={detail?.tshirt_size === 'XXS (34)'}  id="XXS(34)" value="XXS (34)"/>
                                <label className="form-check-label" htmlFor="XXS(34)">XXS (34)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize}  disabled={!editDetail} defaultChecked={detail?.tshirt_size === 'XS (36)'}  id="XS(36)" value="XS (36)"/>
                                <label className="form-check-label" htmlFor="XS(36)">XS (36)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize} disabled={!editDetail}  defaultChecked={detail?.tshirt_size === 'S (38)'}  id="S(38)" value="S (38)"/>
                                <label className="form-check-label" htmlFor="S(38)">S (38)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize} disabled={!editDetail}  defaultChecked={detail?.tshirt_size === 'M (40)'}  id="M(40)" value="M (40)"/>
                                <label className="form-check-label" htmlFor="M(40)">M (40)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize}  disabled={!editDetail} defaultChecked={detail?.tshirt_size === 'L (42)'}  id="L(42)" value="L (42)"/>
                                <label className="form-check-label" htmlFor="L(42)">L (42)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize}  disabled={!editDetail} defaultChecked={detail?.tshirt_size ==='XL (44)'}  id="XL(44)" value="XL (44)"/>
                                <label className="form-check-label" htmlFor="XL(44)"> XL (44)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize}  disabled={!editDetail} defaultChecked={detail?.tshirt_size === 'XXL (46)'}  id="XXL(46)" value="XXL (46)"/>
                                <label className="form-check-label" htmlFor="XXL(46)"> XXL (46)</label>
                                </div>
                                <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="tshirtSize"  onChange={handleTshirtSize}  disabled={!editDetail} defaultChecked={detail?.tshirt_size ==='XXXL (48)' }  id="XXXL(48)" value="XXXL (48)"/>
                                <label className="form-check-label" htmlFor="XXXL(48)"> XXXL (48)  </label>
                                </div>
                                
                                {tShirtSize.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{tShirtSize.error}</div>}


                              
                            </div>   */}
                                          
                            <div className='w-100'></div>
                            {editDetail ? <div className="col-lg-2">
                              
                                {loading ? (<button type="submit" disabled className="btn btn-primary d-inline-block btn-md w-auto auth_btn">
                        <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                        Updating..</button>) :
                            <input type="button" className="btn btn-primary" value="Save" onClick={onSubmit} />
                    }
                            </div>
                                :
                                <div className="col-lg-2">
                                    
                                      <input type="button" className="btn btn-primary" value="Edit" onClick={editPersonalDetail} /> 
                                    
                                </div>}

                            {editDetail && <div className="col-lg-2">
                                <input type="button" className="btn btn-primary" value="Cancel" onClick={handleCancel} />
                            </div>}

                        </div>
                    </form>
                </AccordionBody>
            </Accordion>
        </>
    )
}

export default EditProfileInfo
